import heroMapping from '../components/heroMapping';
import freeTextMapping from '../components/freeTextMapping';
import gridCategoryMapping from '../components/gridCategoryMapping';
import socialMediaMapping from '../components/socialMediaMapping';
import recipesMapping from './recipesMapping';
import recipesComponentMapping from "../components/recipesComponentMapping";

const homepageMapping = (data) => {

    let pageData = JSON.parse(data['resolvedResource#uri{0}'].body);
    let recipesData = JSON.parse(data['homepageRecipesData'].body);

    const mappedData = {};

    let components = pageData.data.relationships.field_components.data;

    mappedData.hero = heroMapping(components.find(component => {
        return component.type === "paragraph--hero_carousel_component"
    }));
    mappedData.freeText = freeTextMapping(components.find(component => {
        return component.type === "paragraph--free_text_component"
    }));
    mappedData.gridCategory = gridCategoryMapping(components.find(component => {
        return component.type === "paragraph--grid_component"
    }));
    mappedData.social = socialMediaMapping(components.find(component => {
        return component.type === "paragraph--social_media_component"
    }));
    mappedData.recipesComponent = recipesComponentMapping(components.find(component => {
        return component.type === "paragraph--recipes_component"
      }));
    mappedData.recipesSection = recipesMapping(recipesData);

    return mappedData;

};


export default homepageMapping;
